import axios from "../axios";
import auth from "./auth";

const Teacher = {
  // 🏫 Répertoire des établissements du supérieur (tour 52) : recherche au fil de la frappe, prof connecté
  searchSchools(q) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/schools/search?q=${encodeURIComponent(q)}`)
        .then(({ data }) => resolve(data?.data || []))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getUniversity() {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-university")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getDegree() {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-degree")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getAreaOfStudy() {
    return new Promise((resolve, reject) => {
      axios
        .get("/get-area-of-study")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  setPaymentSetting(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/payment-setting", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 🔐 Changement d'IBAN : code à 6 chiffres reçu par e-mail
  confirmIbanChange(code) {
    return axios.post("/payment-setting/confirm", { code }).then(({ data }) => data);
  },
  createAdvert(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("adverts/create-advert", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateGeneralInformation(data) {
    
    return new Promise((resolve, reject) => {
      
      axios
        .put("teachers/update-teacher", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getAllAdvertByTeacher() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("get-teacher-adverts")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getStudentById(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`teachers/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
         err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateAdvertStatus(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get("adverts/change-status", id)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateUploadFile(data) {
    return new Promise((resolve, reject) => {
      
      axios
      .post("users/upload-file", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // CV protégé : `path` est le chemin renvoyé par l'API (ex. "teachers/<id>/resume")
  getResumeFile(path) {
    return new Promise((resolve, reject) => {
      axios
        .getBlob(path)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  deleteAdvertByID(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .delete("adverts/delete-advert", id)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateAdvertDetails(id, data) {
    return new Promise((resolve, reject) => {
      
      axios
        .put(`adverts/update-advert/${id}`, data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 📅 « Mon planning » : planning, ce qui manque pour être visible, aperçu des créneaux
  getSchedule() {
    return new Promise((resolve, reject) => {
      axios
        .get("/teacher/schedule")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  saveSchedule(data) {
    return new Promise((resolve, reject) => {
      axios
        .put("/teacher/schedule", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // Accepter (2) ou refuser (3) une demande de cours : POST, réservé au prof du cours. missed : refus automatique
  // au bout des 3 minutes (tour 61), le prof passe hors ligne
  classRequestStatus(data) {
    const url = `/invitations/${data?.id}/${data?.status}`;
    return new Promise((resolve, reject) => {
      (data?.missed ? axios.post(url, { missed: true }) : axios.post(url))
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  upadateNotificationSetting(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("set-teacher-notification", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  giveReviews(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("review-class", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // ⭐ Tour 70 (C) : l'élève modifie son avis sur l'annonce de ce cours (après un nouveau cours)
  editReview(data) {
    return new Promise((resolve, reject) => {
      axios
        .put("review-class", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 💶 Résumé des virements du prof : à venir, en attente, viré, prochain virement, minimum
  payoutSummary() {
    return new Promise((resolve, reject) => {
      axios
        .get("teachers/payouts/summary")
        .then(({ data }) => resolve(data?.data))
        .catch((error) => {
          error?.response?.status === 401 && auth?.destroyToken();
          reject(error);
        });
    });
  },
  getPaymnetDetails() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("payment-details")
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getPaymentDetailsById(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`payment-record/${id}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  // 🧾 Chantier sécurité 4 (N6) : la ligne avec les noms complets des deux parties, pour la facture seulement
  getPaymentInvoice(id) {
    return axios.get(`payment-record/${id}/invoice`).then(({ data }) => data);
  },
  getSubscription(type) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`subscription/get-subscriptions/${type}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  buySubscriptionStripe(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`subscription/purchase-subscription/stripe`, id)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  // 🔒 Tour 69 (A3) : confirm = { password } ou { code } (compte sans mot de passe)
  deleteAccount(id, confirm) {
    return new Promise((resolve, reject) => {
      
      axios
        .deleteWith("teachers/delete-teacher", id, confirm)
        .then(({ data, status }) => {
          // 🕓 Fermeture demandée (tour 43, 202) : de l'argent est encore dû, le compte reste ouvert
          // jusqu'à son virement (puis il est fermé tout seul) ; pas de déconnexion
          if (status === 202) return resolve({ ...data, pending: true });
          resolve(data);
          auth.destroyToken("distory");
        })
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getCardDetails() {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`/get-card-details`)
        .then(({ data }) => resolve(data))
        .catch((error) => {
          reject(error);
          error?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  giveReport(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/send-report-email", data)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 🟢 Page ouverte ou rechargée (reconnexion) : le prof est mis hors ligne (sauf en cours)
  startSession() {
    return new Promise((resolve, reject) => {
      axios
        .post("/teachers/presence/session-start")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // Compte Stripe revérifié (retour de la page Stripe)
  checkStripeStatus() {
    return new Promise((resolve, reject) => {
      axios
        .get("/teachers/check-stripe-status")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // « Mon compte » : état Stripe gardé (l'API n'interroge Stripe que s'il manque ou date de plus d'un jour)
  stripeState() {
    return new Promise((resolve, reject) => {
      axios
        .get("/teachers/stripe-state")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // Lien Stripe (Account Link) pour compléter les informations demandées par Stripe
  // 👀 Ce qui manque au prof pour être réservable (et visible dans la recherche) :
  // { ready, missing: [{ key: "phone" | "iban" | "stripe", reason }] }
  onlineReadiness() {
    return new Promise((resolve, reject) => {
      axios
        .get("/teachers/online-readiness")
        .then(({ data }) => resolve(data?.data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 🧭 Étapes de la fiche (tour 63, B3) : { photo, slots, video }
  ficheSteps() {
    return axios
      .get("/teachers/profile-steps")
      .then(({ data }) => data?.data)
      .catch((err) => {
        err?.response?.status === 401 && auth?.destroyToken();
        throw err;
      });
  },
  stripeAccountLink() {
    return new Promise((resolve, reject) => {
      axios
        .get("/teachers/stripe-identity-link")
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 💻 « Ne plus me le rappeler » du conseil de l'ordinateur (tour 49), gardé sur le compte
  setComputerHint(off) {
    return axios.put("/teacher/computer-hint", { off }).then(({ data }) => data);
  },
  updateStatus(id,status) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/update-online-status/${id}/${status}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 📊 Statistiques v2 (tour 46) : période (7, 30, 365, all) et annonce facultative ; 403
  // premium_required sans Premium. Paramètres par axios.query (axios.get prend un segment d'adresse)
  getStatistics({ period = "30", advert } = {}) {
    return axios.query("/teacher/statistics", { params: { period, ...(advert ? { advert } : {}) } }).then(({ data }) => data);
  },
  getOverAllStacs() {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`/get-teacher-statistics`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateWaitingRoomStatus() {
    return new Promise((resolve, reject) => {
      
      axios
        .put(`/subscription/update-waiting-room-status`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getUserSubscriptions() {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`/subscription/get-user-subscription`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  updateAutoRenewalStatus(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .put(`/subscription/update-auto-renewal/${id}`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  getStudentCount(){
    return new Promise((resolve,reject) => {
      
      axios
        .get(`get-student-online-count`)
        .then(({data}) => resolve(data))
        .catch((err)=>{
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    })
  } 
}

export default Teacher;
